<template>
  <div class="prelab-loading card border-0 shadow-sm">
    <div class="card-body text-center py-4 px-4">
      <div class="spinner-border text-primary mb-3" aria-hidden="true"></div>
      <output class="visually-hidden" aria-live="polite" aria-atomic="true">
        <template v-if="!errorMessage">Loading pre-lab data...</template>
        <template v-else>{{ errorMessage }}</template>
      </output>
      <h6 class="fw-semibold mb-1">Loading Pre-Lab Data</h6>
      <p class="text-muted small mb-0" v-if="!errorMessage">
        Restoring your saved progress and setup...
      </p>
      <div
        v-else
        class="alert alert-warning small text-start mt-3 mb-0"
        role="alert"
      >
        {{ errorMessage }}
      </div>
      <div
        v-if="showActions"
        class="d-flex flex-wrap gap-2 justify-content-center mt-3"
      >
        <button class="btn btn-sm btn-outline-primary" @click="$emit('retry')">
          Retry
        </button>
        <button
          class="btn btn-sm btn-outline-secondary"
          @click="$emit('continue')"
        >
          Continue without restore
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PreLabLoading",
  emits: ["retry", "continue"],
  props: {
    errorMessage: {
      type: String,
      default: ""
    },
    showActions: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.prelab-loading {
  max-width: 420px;
  width: 100%;
}
</style>
